import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CartAmountToggle from '../../ShopComponents/CartAmountToggle';
import LoadingSpinner from '../../common/LoadingSpinner';
import axios from 'axios';

export default function ProductDetails() {
  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/products/${id}`);
        setProduct(response.data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch product details');
        console.error('Error fetching product:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  if (loading) return (
    <LoadingSpinner 
      text="Loading Product Details..." 
      textColor="#006400"
      spinnerColor="#006400"
      size="medium"
    />
  );
  
  if (error) return <div className="cs_error_message">{error}</div>;
  if (!product) return <div className="cs_error_message">Product not found</div>;

  return (
    <div className="cs_product_details">
      <CartAmountToggle 
        quantity={quantity} 
        setQuantity={setQuantity}
        stock={product.stock}
        price={product.price}
        discount={product.discount}
      />
    </div>
  );
}